














































































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import TopNavigationComponent from "./Components/TopNavigation.vue";
import TechnicalApplicationComponent from "./Components/TechnicalApplication.vue";
import ApplicationBudgetComponent from "./Components/ApplicationBudget.vue";
import DueDeligenceComponent from "./Components/DueDeligence.vue";
import SafeguardComponent from "./Components/SafeGuard.vue";
import LogframeworkComponent from "./Components/Logframework.vue";
import GenericComponent from "./Components/Generic.vue";
import DocumentChecklistComponent from "./Components/DocumentChecklist.vue";
import ValidationMessageComponent from '@/components/common/ValidationMessage/ValidationMessage.vue';
import ButtonPanelComponent from "./Components/ButtonPanel.vue";
import { Workspace, validationData, ApplicationSubmit } from "@/entities";
import { AppConstants as _app } from "@/shared/app.constants";
import { Feedback } from "@/entities";

const namespace: string = "conceptNote";

@Component({
    components: {
        TopNavigationComponent,
        TechnicalApplicationComponent,
        ApplicationBudgetComponent,
        DueDeligenceComponent,
        LogframeworkComponent,
        GenericComponent,
        SafeguardComponent,
        DocumentChecklistComponent,
        ButtonPanelComponent,
        ValidationMessageComponent
    }
})
export default class WorkspaceComponent extends Vue {
    @State(namespace) conceptNote!: Workspace;
    @State("validation") validation!: validationData;
    @State("feedback") feedback!: Feedback;
    @Action("setValidation", { namespace: "validation" }) setValidation: any;
    @Action("updateLanguage", { namespace }) updateLanguage: any;
    @Action("getConceptNote", { namespace }) getConceptNote: any;
    @Action("showNotification", { namespace }) showNotification: any
    @Action("updateTopMenu", { namespace: "conceptNote" }) updateMenu: any;
    @Action("updateSubMenu", { namespace }) updateSubMenu: any;
    @Action("saveConceptNote", { namespace: "conceptNote" }) save: any;
    @Action("saveAppData", { namespace: "conceptNote" }) saveAppData: any;
    @Action("saveApplicationData", { namespace }) saveData: any;
    @Action("getFeedbackInfo", { namespace: "feedback" }) getFeedbackInfo: any;
    @Action("createFeedbackHeader", { namespace: "feedback" }) createFeedbackHeader: any;
    @Action("getFeedbacks", { namespace: "feedback" }) getFeedbacks: any;
    @Action("resolve", { namespace: "feedback" }) resolveFeedback: any;
    @Action("reopen", { namespace: "feedback" }) reopenFeedback: any;
    @Getter("rootTemplate", { namespace }) schema: any;
    @Getter("topMenu", { namespace }) topMenu: string;
    @Getter("subMenu", { namespace }) subMenu: string;
    @Getter("projectTitle", { namespace }) projectTitle: string;
    @Getter("maxAmountPossible", { namespace }) maxFundAllocated: any;
    @Getter("grantType", { namespace }) grantType: any;
    @Getter("_appUser", { namespace: "RootApp" }) _username!: string;
    @Getter("_appUserId", { namespace: "RootApp" }) _userid!: number;
    @Getter("projectYrs", { namespace: "conceptNote" }) years: any;
    @Getter("reportingFrequency", { namespace: "conceptNote" }) reportingFreq: any;
    @Getter("appSubmit", { namespace }) appSubmit: ApplicationSubmit;

    $refs: {
        technicalApp: TechnicalApplicationComponent;
        appBudget: ApplicationBudgetComponent;
    };

    /** declare variables */
    isReadOnly: boolean = true;
    isDirty: boolean = false;
    valid: boolean = true;
    update = 0;
    loading: boolean = false;
    selectedTopMenu: string = "technicalApplication";
    selectedSubMenu: string = "";
    actions = _app.actions;
    subjects = _app.subjects;
    appStatus = [
        _app.conceptNoteStatus.draft,
        _app.conceptNoteStatus.negotiationResponse,
        // _app.conceptNoteStatus.RAGdraft,
        // _app.conceptNoteStatus.ragNegotiationResponse
    ];
    errShow = true;
    errorCount = 0;
    prevTopmenu = "";
    componentKey = 0;

    mounted() {
        this.updateLanguage(this.$root.$i18n.locale);
    }

    get sideMenu() {
        if (this.schema.properties) {
            // Set style if the template doesn't have x-class property
            for (let pKey in this.schema.properties) {
                if (this.schema.properties[pKey]) {
                    for (let cKey in this.schema.properties[pKey].properties) {
                        if (_app.templateSections[cKey] && !this.schema.properties[pKey].properties[cKey]["x-class"]) {
                            this.schema.properties[pKey].properties[cKey]["x-class"] = _app.templateSections[cKey]["x-class"];
                        }
                    }
                }
            }

            return this.schema.properties[this.selectedTopMenu]
        } else {
            return {};
        }
    }

    get formOptions() {
        return {
            //@ts-ignore
            "rights": this.$can("manage", "genericFeedback") ? _app.actions.manage : _app.actions.read,
            "entity": _app.entities.conceptNote,
            "transactionId": this.conceptNote.conceptNote.ConceptNoteId,
            "user": this._userid,
            "feedbacks": this.feedback.feedbackHeaders,
            "actions": {
                createHeader: this.createFeedbackHeader,
                list: this.getFeedbacks,
                resolveFeedback: this.resolveFeedback,
                reopenFeedback: this.reopenFeedback,
                updateFeedback: this.$services.comment.Update
            }
        };
    }

    get permission() {
        if (this.conceptNote && this.conceptNote.conceptNote && this.conceptNote.conceptNote.WorkflowInfo && this.conceptNote.conceptNote.WorkflowInfo.CurrentStep) {
            //@ts-ignore
            return (this.$can(this.actions.manage, this.subjects.conceptNote) && (this.appStatus.includes(this.conceptNote.conceptNote.WorkflowStatusId) || this.conceptNote.conceptNote.WorkflowInfo.CurrentStep.ReturnStatus === 1) ||
                //@ts-ignore
                (this.$can(this.actions.manage, this.subjects.program) || this.$can(this.actions.fullaccess, this.subjects.all))
            )
        }
    }

    // get indirectCost() {
    //     if (this.conceptNote.conceptNote.BudgetType == 'BEST_CN') {
    //         return 0;
    //     } else {
    //         return this.conceptNote.conceptNote.IndirectCost;
    //     }
    // }

    getFeedbackHeader(rowKey) {
    
      if (this.formOptions && this.formOptions.feedbacks) {
        return this.formOptions.feedbacks.find(x => x.RowKey === rowKey);
      } else {
          return null;
      }
    }

    feedbackInfo() {
        setTimeout(() => {
            this.getFeedbackInfo({ entity: _app.entities.conceptNote, transactionId: this.conceptNote.conceptNote.ConceptNoteId });
        }, 1000)
    }

    setFromBudgetValues(obj) {
       const { totalProjectBudget, sosFundReq, directEligbleCost, totalBudget, sumTotalBudget, totMatchingFund, percOfCofinance } = obj;

        if (this.conceptNote.conceptNote.BudgetType == 'RAG' || this.conceptNote.conceptNote.BudgetType == 'CAG') {
            // for RAG project
            if (totalProjectBudget && totalProjectBudget.Total) {
                this.conceptNote.data['totalProjectBudgect'] = totalProjectBudget.Total.value || 0;
            }
        } else if (this.conceptNote.conceptNote.BudgetType == 'TSG' || this.conceptNote.conceptNote.BudgetType == 'TSGAWI') {
            // for TSG sos project
            if (sosFundReq && sosFundReq.Total) {
                this.conceptNote.data['fundingRequests'] = sosFundReq.Total.value || 0;
            }
            if (totalProjectBudget && totalProjectBudget.Total) {
                this.conceptNote.data['totalProjectBudgect'] = totalProjectBudget.Total.value || 0;
            }
            if (this.conceptNote.data['totalProjectBudgect']) {
                this.conceptNote.data['amountOfMatchingFund'] = this.conceptNote.data['totalProjectBudgect'] - (this.conceptNote.data['fundingRequests'] || 0);
            }
        } else if (this.conceptNote.conceptNote.BudgetType == 'Tiger') {
            // for TSG tiger project
            if (totalBudget && totalBudget.Total) {
                this.conceptNote.data['totalProjectBudgect'] = (totalBudget.Total.value || 0) + (totalBudget.matchFunding || 0);
                this.conceptNote.data['fundingRequests'] = (totalBudget.Total.value || 0);
            }
        } else if (this.conceptNote.conceptNote.BudgetType == 'Other') {
            // other sos project
            if (sumTotalBudget && sumTotalBudget.Total && sumTotalBudget.Total) {
                this.conceptNote.data['totalProjectBudgect'] = sumTotalBudget.Total.value || 0;
            }
            if (totMatchingFund && totMatchingFund.Total && totMatchingFund.Total) {
                this.conceptNote.data['amountOfMatchingFund'] = totMatchingFund.Total.value || 0;

                if (this.conceptNote.data['totalProjectBudgect']) {
                    this.conceptNote.data['fundingRequests'] = (this.conceptNote.data['totalProjectBudgect'] || 0) - (this.conceptNote.data['amountOfMatchingFund'] || 0);
                }
            }
        } else if (this.conceptNote.conceptNote.BudgetType == 'BEST_CN'){
            if (totalProjectBudget && totalProjectBudget.Total) {
                this.conceptNote.data['totalProjectBudgect'] = totalProjectBudget.Total.value || 0;
            }
            if(percOfCofinance && percOfCofinance.Total && this.conceptNote.data['totalProjectBudgect']) {
                this.conceptNote.data['amountOfMatchingFund'] = (this.conceptNote.data['totalProjectBudgect'] * percOfCofinance.Total.value) / 100;
                this.conceptNote.data['fundingRequests'] = (this.conceptNote.data['totalProjectBudgect'] || 0) - (this.conceptNote.data['amountOfMatchingFund'] || 0);
            }
        }
    }

    download() {        
        // const conceptNoteData =this.conceptNote.conceptNote.BudgetType == 'Tiger' ? { ...this.conceptNote.data, amountOfMatchingFund:  this.conceptNote.data.applicationBudget.summary.totalBudget.matchFunding || 0 } : this.conceptNote.data;
             let conceptNoteData;
switch (this.conceptNote.conceptNote.BudgetType) {
  case 'Tiger':
    conceptNoteData = {
      ...this.conceptNote.data,
      amountOfMatchingFund: this.conceptNote.data.applicationBudget.summary.totalBudget.matchFunding || 0
    };
    break;
  case 'CAG':
    conceptNoteData = {
      ...this.conceptNote.data,
      fundingRequests: this.conceptNote.data.totalProjectBudgect || 0
    };
    break;
  default:
    conceptNoteData = this.conceptNote.data;
    break;
}
             this.$services.pdf.generate({
                "entity": "ConceptNote",
                "schema": this.schema,
                "data": conceptNoteData,
                "user": this._username,
                "currency": this.conceptNote.conceptNote.BudgetCurrency,
                "id": this.conceptNote.conceptNote.ConceptNoteId,
                "code": this.conceptNote.conceptNote.Code,
                "type": this.conceptNote.templates["IsRAGTemplate"] ? "RAG" : "TSG",
                "years": this.years,
                "Quaters": this.reportingFreq,
                "fileName": "Concept Note_Application",
                "checklist": this.appSubmit.checklist,
                "logSchema": this.conceptNote.logSchema        
        });
    }

    /*** save if form is dirty */
    saveDirty(callback: any) {
        if (this.isDirty && !this.isReadOnly) {
            // save the data if form is dirty
            this.isDirty = false;
            this.prevTopmenu = this.selectedTopMenu;
            this.saveData({
                data: this.conceptNote.data,
                id: this.conceptNote.conceptNote.ConceptNoteId,
                section: this.selectedTopMenu
            })
                .then((resp) => {
                    callback(resp);
                });
        } else {
            callback();
        }
    }

    /** update the selected key on top menu selection */
    topMenuChanged(key) {
        this.saveDirty((resp) => {
            this.selectedTopMenu = key;
            //checks sectionwise errors
            if (resp && resp.success) {
                if (resp.errMsg && resp.errMsg.length > 0) {
                    this.errorCount = resp.errMsg.length
                    this.conceptNote.validationMessages = resp.errMsg
                }
                else {
                    this.errorCount = 0;
                }
            }
        });
    }

    /** update the sub menu key */
    subMenuChanged(menu) {
        this.saveDirty((resp) => {
            this.updateSubMenu(menu);
            if (resp && resp.success) {
                if (resp.errMsg && resp.errMsg.length > 0) {
                    this.errorCount = resp.errMsg.length
                    this.conceptNote.validationMessages = resp.errMsg
                }
                else {
                    this.errorCount = 0;
                }
            }
        });
    }

    /** set is-dirty flag  */
    setDirtyFlag(flag) {
        if (!this.isReadOnly) {
            this.isDirty = flag;
        }
    }

    /** Save the application */
    saveApplication(context: string) {
        this.loading = true;
        if (context === 'submit') {
            return this.saveAppData({
                data: this.conceptNote.data,
                id: this.conceptNote.conceptNote.ConceptNoteId,
                section: null
            })
                // .then(this.$refs.appBudget.save);
                .then((success) => {
                    if (success) {
                        return this.save({
                            data: this.conceptNote.conceptNote,
                            id: this.conceptNote.conceptNote.ConceptNoteId,
                            context
                        });
                    }
                })
                .then(() => {
                    this.$router.push({
                        name: "dashboard",
                        query: {}
                    });
                });
        } else {
            this.isDirty = false;
            return this.saveAppData({
                data: this.conceptNote.data,
                id: this.conceptNote.conceptNote.ConceptNoteId
            }).then((success) => {
                if (success) {
                    return this.save({
                        data: this.conceptNote.conceptNote,
                        id: this.conceptNote.conceptNote.ConceptNoteId,
                        context
                    });
                }
            }).then((resp) => {
                this.loading = false;
                return resp;
            }).catch(() => {
                this.loading = false;
            });
        }
    }

    /** Add new file to the physical location*/
    onFileChanged(data: any) {
        this.saveAppData({
            data: this.conceptNote.data,
            id: this.conceptNote.conceptNote.ConceptNoteId
        });
    }

    /** back to summary page */
    back() {
        if (this.isReadOnly) {
            this.$router.push({
                name: "dashboard"
            });
        } else {
            this.$router.push({
                name: "applConceptNoteSummary"
            });
        }
    }

    /** show validations */
    showValidation(msgs: any) {
        this.conceptNote.validationMessages = msgs;
        this.conceptNote.showValidationDilog = true;
    }
    // validation dialog closed
    validationDialogClosed() {
        this.conceptNote.showValidationDilog = false;
        //this.conceptNote.validationMessages = [];
    }

    // redirect to application form on validation message click
    validationMessageClicked(msg: any) {
        this.conceptNote.showValidationDilog = false;
        //this.conceptNote.validationMessages = [];
        if (msg.SubSectionKey) {
            this.$router.push({
                name: "conceptnoteapply",
                params: { conceptNoteId: this.conceptNote.conceptNote.ConceptNoteId.toString(), section: msg.SectionKey },
                hash: `#${msg.SubSectionKey}`
            }).catch(() => { });
        } else {
            this.$router.push({
                name: "conceptnoteapply",
                params: { conceptNoteId: this.conceptNote.conceptNote.ConceptNoteId.toString(), section: msg.SectionKey || this.selectedTopMenu }
            }).catch(() => { });
        }
    }

    /*** Watch methods */
    @Watch("$vuetify.lang.current")
    onPropertyChanges(value: any, oldvalue: any) {
        this.updateLanguage(value);
    }

    @Watch("selectedTopMenu")
    onMenuChanges(value: any, oldvalue: any) {
        this.updateMenu(value);

        if (this.conceptNote.conceptNote && this.conceptNote.conceptNote.ConceptNoteId) {
            if (this.isReadOnly) {
                this.$router.push({
                    name: "viewConceptNote",
                    params: { conceptNoteId: this.conceptNote.conceptNote.ConceptNoteId.toString(), section: value }
                }).catch(() => { });
            } else {
                this.$router.push({
                    name: "conceptnoteapply",
                    params: { conceptNoteId: this.conceptNote.conceptNote.ConceptNoteId.toString(), section: value }
                }).catch(() => { });
            }
        }
    }

    @Watch("$route", { immediate: true, deep: true })
    onUrlChange(changedRoute: any, previousRoute) {
        if (changedRoute && changedRoute.name === 'conceptnoteapply') {
            this.isReadOnly = false;

            //this.selectedTopMenu =  this.application.selectedItem;
            if (changedRoute.params.section) {
                this.selectedTopMenu = changedRoute.params.section;
            }

            if (changedRoute.hash) {
                this.updateSubMenu({ key: this.selectedTopMenu, subMenu: changedRoute.hash.substr(1) });
            }

            if (!previousRoute || previousRoute.name !== changedRoute.name || changedRoute.params.applicationId !== previousRoute.params.applicationId) {
                const conceptNoteId = changedRoute.params.conceptNoteId;
                this.getConceptNote(conceptNoteId)
                    .then((data: any) => {
                        this.componentKey += 1;
                    });
                this.getFeedbackInfo({ entity: _app.entities.conceptNote, transactionId: conceptNoteId });
                this.errorCount = 0;
            }
            // this.update += 1;
        } else if (changedRoute && changedRoute.name === 'viewConceptNote') {
            this.isReadOnly = true;

            if (changedRoute.params.section) {
                this.selectedTopMenu = changedRoute.params.section;
            }

            if (!previousRoute || previousRoute.name !== changedRoute.name || changedRoute.params.applicationId !== previousRoute.params.applicationId) {
                const conceptNoteId = changedRoute.params.conceptNoteId;
                this.getConceptNote(conceptNoteId)
                    .then((data: any) => {
                        this.componentKey += 1;
                    });
                this.getFeedbackInfo({ entity: _app.entities.conceptNote, transactionId: conceptNoteId });
                this.errorCount = 0;
            }
        }
    }
}
